var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.page)?_c('div',{staticClass:"container"},[_c('div',{staticClass:"page",attrs:{"id":"wpPostEmbed"},domProps:{"innerHTML":_vm._s(_vm.page)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }